import AssignmentPoolIgnore from "./AssignmentPoolIgnore";
import Editor from "./Editor";

export default class AssignmentPool {
    private readonly _id: string;
    private readonly _assignmentId: string;
    private readonly _createdAt: Date;
    private readonly _editors: Editor[];
    private readonly _ignores: AssignmentPoolIgnore[];
    private readonly _deletedAt: Date | null;
    private readonly _acceptedAt: Date | null;
    private readonly _acceptedBy: Editor | null;
    constructor({
        id,
        assignmentId,
        createdAt,
        deletedAt,
        acceptedAt,
        editors,
        ignores,
        acceptedBy,
    }) {
        this._id = id;
        this._assignmentId = assignmentId;
        this._createdAt = new Date(createdAt);
        this._deletedAt = deletedAt ? new Date(deletedAt) : null;
        this._acceptedAt = acceptedAt ? new Date(acceptedAt) : null;
        this._acceptedBy = acceptedBy ? new Editor(acceptedBy) : null;
        this._editors = editors.map(e => new Editor(e));
        this._ignores = ignores.map(i => new AssignmentPoolIgnore(i, this))
    }

    get id(): string {
        return this._id;
    }


    get assignmentId(): string {
        return this._assignmentId;
    }

    get createdAt(): Date {
        return this._createdAt;
    }

    get editors(): Editor[] {
        return this._editors;
    }

    get ignores(): AssignmentPoolIgnore[] {
        return this._ignores;
    }

    get deletedAt(): Date | null {
        return this._deletedAt;
    }

    get acceptedAt(): Date | null {
        return this._acceptedAt;
    }

    get acceptedBy(): Editor | null {
        return this._acceptedBy;
    }

    get isActive() : boolean {
        return !(this._acceptedAt || this._deletedAt);
    }
}
